import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import '../styles/ContactoPage.css';

const ContactoPage = () => {
  const [formData, setFormData] = useState({
    nombre: '',
    empresa: '',
    email: '',
    telefono: '',
    servicio: '',
    mensaje: ''
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    alert('¡Gracias por su mensaje! Nos pondremos en contacto con usted pronto.');
    setFormData({
      nombre: '',
      empresa: '',
      email: '',
      telefono: '',
      servicio: '',
      mensaje: ''
    });
  };

  return (
    <div className="contacto-page">

      {/* HERO CON IMAGEN DE FONDO */}
      <section
        className="page-hero"
      >
        <div className="page-hero-overlay" />
        <div className="page-hero-content">
          <p className="page-hero-tagline">Estamos para ayudarle</p>
          <h1>Contáctenos</h1>
          <p>Estamos listos para atender sus necesidades</p>
        </div>
      </section>

      <section className="contacto-content">
        <div className="container">
          <div className="contacto-grid">
            <div className="contacto-info">
              <h2>Información de Contacto</h2>
              <p>
                Estamos disponibles para atender sus consultas y brindarle la mejor solución
                para sus necesidades de limpieza y servicios integrales.
              </p>

              <div className="info-items">
                <div className="info-item">
                  <div className="info-icon">📧</div>
                  <div className="info-text">
                    <h4>Email</h4>
                    <p>sydiez@ecolimpiezaag.com</p>
                  </div>
                </div>

                <div className="info-item">
                  <div className="info-icon">📱</div>
                  <div className="info-text">
                    <h4>Teléfono</h4>
                    <p>+51 944 170 506</p>
                  </div>
                </div>

                <div className="info-item">
                  <div className="info-icon">📍</div>
                  <div className="info-text">
                    <h4>Ubicación</h4>
                    <p>Perú</p>
                  </div>
                </div>

                <div className="info-item">
                  <div className="info-icon">🕒</div>
                  <div className="info-text">
                    <h4>Horario de Atención</h4>
                    <p>Lunes a Sábado: 7:00 AM - 7:00 PM</p>
                  </div>
                </div>
              </div>

              <div className="social-section">
                <h4>Síguenos en redes sociales</h4>
                <div className="social-links">
                  <a href="#" className="social-link">Facebook</a>
                  <a href="#" className="social-link">LinkedIn</a>
                  <a href="#" className="social-link">Instagram</a>
                </div>
              </div>
            </div>

            <div className="contacto-form-container">
              <h2>Envíanos un mensaje</h2>
              <form className="contacto-form" onSubmit={handleSubmit}>
                <div className="form-group">
                  <label htmlFor="nombre">Nombre Completo *</label>
                  <input
                    type="text"
                    id="nombre"
                    name="nombre"
                    value={formData.nombre}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="empresa">Empresa</label>
                  <input
                    type="text"
                    id="empresa"
                    name="empresa"
                    value={formData.empresa}
                    onChange={handleChange}
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="email">Correo Electrónico *</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="telefono">Teléfono</label>
                  <input
                    type="tel"
                    id="telefono"
                    name="telefono"
                    value={formData.telefono}
                    onChange={handleChange}
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="servicio">Servicio de Interés</label>
                  <select
                    id="servicio"
                    name="servicio"
                    value={formData.servicio}
                    onChange={handleChange}
                  >
                    <option value="">Seleccione un servicio</option>
                    <option value="limpieza">Limpieza</option>
                    <option value="auxiliares">Servicios Auxiliares</option>
                    <option value="mantenimiento">Mantenimiento e Ingeniería</option>
                    <option value="rrhh">Recursos Humanos</option>
                    <option value="sociosanitarios">Servicios Sociosanitarios</option>
                    <option value="soluciones">Soluciones Integrales</option>
                  </select>
                </div>

                <div className="form-group">
                  <label htmlFor="mensaje">Mensaje *</label>
                  <textarea
                    id="mensaje"
                    name="mensaje"
                    rows="5"
                    value={formData.mensaje}
                    onChange={handleChange}
                    required
                  ></textarea>
                </div>

                <button type="submit" className="btn-submit">
                  Enviar Mensaje
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>

      <section className="servicios-rapidos">
        <div className="container">
          <h2>Nuestros Servicios</h2>
          <div className="servicios-rapidos-grid">
            <Link to="/servicios/limpieza" className="servicio-quick">
              <div className="quick-icon">🧹</div>
              <h4>Limpieza</h4>
            </Link>
            <Link to="/servicios/auxiliares" className="servicio-quick">
              <div className="quick-icon">👥</div>
              <h4>Servicios Auxiliares</h4>
            </Link>
            <Link to="/servicios/mantenimiento" className="servicio-quick">
              <div className="quick-icon">🔧</div>
              <h4>Mantenimiento</h4>
            </Link>
            <Link to="/servicios/rrhh" className="servicio-quick">
              <div className="quick-icon">💼</div>
              <h4>RRHH</h4>
            </Link>
            <Link to="/servicios/sociosanitarios" className="servicio-quick">
              <div className="quick-icon">🏥</div>
              <h4>Sociosanitarios</h4>
            </Link>
            <Link to="/servicios/soluciones-integrales" className="servicio-quick">
              <div className="quick-icon">✨</div>
              <h4>Soluciones Integrales</h4>
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ContactoPage;
